import { useCallback, useEffect } from "react";
import "../../Dashboard/Dashboard.scss";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import DashboardFilter from "../../Dashboard/DashboardFilter";
import OpenATECases from "../../Dashboard/OpenATECases";
import MaintenanceRequests from "../../Dashboard/MaintenanceRequests";
import {
  getATECasesStatistics,
  getBuildingsStatistics,
  getContractInformationStatistics,
  getDashboardCards,
  getMaintenanceAppointmentsStatistics,
  resetFilterData,
} from "src/redux/slices/dashboardSlice";
import { getBMCRatingStatistics } from "src/redux/slices/dashboardSlice";
import { useDispatch } from "react-redux";
import DashboardSLACard from "../../Dashboard/DashboardSLACard";
import DashboardResolutionTimeCard from "../../Dashboard/DashboardResolutionTimeCard";
import DashboardCompanyReviewCard from "../../Dashboard/DashboardCompanyReviewCard";
import AssignedPropertiesCard from "../../Dashboard/AssignedPropertiesCard";
import ContractsCard from "../../Dashboard/ContractsCard";
import PreventiveMaintenanceAppointmentsCard from "../../Dashboard/PreventiveMaintenanceAppointmentsCard";
import CDDashboardFilter from "./CDDashboardFilter";
import { useTranslation } from "react-i18next";
import BMCRatingCharts from "./BMCRatingCharts";
import { getAssignedBuildingsLookup } from "src/redux/slices/lookupSlice";
import useOnPageLeave from "src/hooks/useOnPageLeave";

Chart.register(CategoryScale);

const CDDashboard = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "dashboard"]);

  useEffect(() => {
    dispatch(getBMCRatingStatistics() as any);
    dispatch(getContractInformationStatistics() as any);
    dispatch(getATECasesStatistics() as any);
    dispatch(getDashboardCards() as any);
    dispatch(getBuildingsStatistics() as any);
    dispatch(getMaintenanceAppointmentsStatistics() as any);
    dispatch(getAssignedBuildingsLookup() as any);
  }, [dispatch]);

    const onPageLeave = useCallback(() => {
      dispatch(resetFilterData());
    }, []);
  useOnPageLeave(onPageLeave);


  return (
    <div className="flex justify-between dashboard">
      <div className="">
        <div className="dashboard-outer-container">
          <div className="dashboard-inner-container">
            <div className="dashboard-filter mb-3">
              <CDDashboardFilter />
            </div>

            <div className="card-container">
              <div className="row mb-3">
                <DashboardSLACard />
                <DashboardResolutionTimeCard />
                <DashboardCompanyReviewCard title={t("averageBMCRating")} />
              </div>
              <div className="row chart-carts  mb-3">
                <OpenATECases title={t("faults")} />
                <BMCRatingCharts />
              </div>
              <div className="row chart-carts">
                <PreventiveMaintenanceAppointmentsCard />
                <ContractsCard />
                <AssignedPropertiesCard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CDDashboard;
